// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { isApolloError } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import { getStatusCode } from '@confluence/error-boundary/entry-points/isStatusCodeError.ts';

export const shouldMarkErrorAsHandled = (
	error: ApolloErrorInterop | Error | undefined,
): boolean => {
	if (!error) return true;
	const statusCode = isApolloError(error)
		? getStatusCode(error?.graphQLErrors?.[0])
		: getStatusCode(error);
	if (!statusCode) return true;
	return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};
